import { LockKey } from "@phosphor-icons/react";

/**
 * Compact trust badge that sits under every Buy button on the Buy Credits /
 * Buy Upgrades pages: Visa + Mastercard glyphs + "Secured payments" line.
 * SVGs are inline so no external requests are needed.
 */
export default function PaymentTrust({ className = "" }) {
  return (
    <div
      data-testid="payment-trust"
      className={`flex items-center justify-center gap-2 pt-3 mt-3 border-t border-slate-200/70 dark:border-slate-700/70 text-slate-500 dark:text-slate-400 ${className}`}
    >
      <div className="flex items-center gap-2" aria-label="Accepted cards">
        <VisaLogo />
        <MastercardLogo />
      </div>
      <span className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest">
        <LockKey size={12} weight="fill" className="text-emerald-500" />
        Secured payments
      </span>
    </div>
  );
}

function VisaLogo() {
  return (
    <svg
      viewBox="0 0 48 16"
      role="img"
      aria-label="Visa"
      className="h-6 w-auto rounded-[3px] bg-white ring-1 ring-slate-200 dark:ring-slate-700 px-1.5 py-[2px]"
    >
      <text
        x="50%"
        y="55%"
        textAnchor="middle"
        dominantBaseline="middle"
        fontFamily="'Helvetica Neue', Arial, sans-serif"
        fontWeight="900"
        fontStyle="italic"
        fontSize="12"
        letterSpacing="-0.5"
        fill="#1a1f71"
      >
        VISA
      </text>
    </svg>
  );
}

function MastercardLogo() {
  return (
    <svg
      viewBox="0 0 40 24"
      role="img"
      aria-label="Mastercard"
      className="h-6 w-auto rounded-[3px] bg-white ring-1 ring-slate-200 dark:ring-slate-700 px-1.5 py-[2px]"
    >
      <circle cx="15" cy="12" r="7" fill="#EB001B" />
      <circle cx="25" cy="12" r="7" fill="#F79E1B" />
      <path
        d="M20 6.6a7 7 0 0 1 0 10.8 7 7 0 0 1 0-10.8z"
        fill="#FF5F00"
      />
    </svg>
  );
}
